// All wonder-of-the-world tiles rendered on the Home page. Feb 2026:
// the strip picks 4 per day using day-of-year so kids see fresh
// landmarks every 24h without any client-side timers.
export const WONDERS = [
  { slug: "eiffel",              code: "fr", name: "Eiffel Tower",   where: "France",     bg: "bg-sky-200"      },
  { slug: "pyramids",            code: "eg", name: "The Pyramids",   where: "Egypt",      bg: "bg-amber-200"    },
  { slug: "taj",                 code: "in", name: "Taj Mahal",      where: "India",      bg: "bg-rose-200"     },
  { slug: "statue-of-liberty",   code: "us", name: "Liberty",        where: "USA",        bg: "bg-emerald-200"  },
  { slug: "great-wall",          code: "cn", name: "Great Wall",     where: "China",      bg: "bg-lime-200"     },
  { slug: "colosseum",           code: "it", name: "Colosseum",      where: "Italy",      bg: "bg-orange-200"   },
  { slug: "sydney-opera",        code: "au", name: "Sydney Opera",   where: "Australia",  bg: "bg-cyan-200"     },
  { slug: "machu-picchu",        code: "pe", name: "Machu Picchu",   where: "Peru",       bg: "bg-teal-200"     },
  { slug: "mount-fuji",          code: "jp", name: "Mount Fuji",     where: "Japan",      bg: "bg-pink-200"     },
  { slug: "christ-redeemer",     code: "br", name: "Christ Redeemer",where: "Brazil",     bg: "bg-yellow-200"   },
  { slug: "big-ben",             code: "gb", name: "Big Ben",        where: "UK",         bg: "bg-indigo-200"   },
  { slug: "burj-khalifa",        code: "ae", name: "Burj Khalifa",   where: "UAE",        bg: "bg-violet-200"   },
];

function dayOfYear() {
  const d = new Date();
  const start = new Date(d.getFullYear(), 0, 0);
  return Math.floor((d - start) / 86400000);
}

// Returns 4 wonders that rotate daily. Uses a rolling window so every
// wonder cycles through every slot fairly across the year.
export function todaysWonders(count = 4) {
  const start = dayOfYear() % WONDERS.length;
  return Array.from({ length: count }, (_, i) => WONDERS[(start + i) % WONDERS.length]);
}
